import './AddAccount.sass';

import React, { FC } from 'react';
import { useRoute } from 'react-router5';

import { Auth } from '$shared/components';
import { useTranslator } from '$hooks';
import { ScrollView } from '$uikit';

export const AddAccount: FC = () => {
  const t = useTranslator();
  const { route } = useRoute();
  // With a return target the user is signing in to an existing account
  const isLogin = !!route.params.target;

  return (
    <ScrollView>
      <div className="AddAccount">
        <div className="AddAccount__content">
          <div className="AddAccount__title">
            {isLogin
              ? t('add_account_login_title', {
                  defaultValue: 'Sign in to another account',
                })
              : t('add_account_title')}
          </div>
          <div className="AddAccount__caption">
            {isLogin
              ? t('add_account_login_caption', {
                  defaultValue: 'Sign in to the account you want to connect',
                })
              : t('add_account_caption')}
          </div>
          <div className="AddAccount__form">
            <Auth />
          </div>
        </div>
      </div>
    </ScrollView>
  );
};
